export const STAGE_VALUES = {
  UNAVAILABLE: 0,
  OFF: 1,
  ON: 2,
  TRIM: 3,
} as const;

export const CHART_FONT_FAMILY = "'Red Hat Display', sans-serif";

/** Green aligned with the sequencer table cells. */
export const CHART_GREEN = '#adff00';
export const CHART_GREEN_RGB = '173, 255, 0';

export const STAGE_COLORS: Record<number, string> = {
  [STAGE_VALUES.TRIM]: CHART_GREEN,
  [STAGE_VALUES.ON]: CHART_GREEN,
};

export const STAGE_LABELS: Record<number, string> = {
  [STAGE_VALUES.UNAVAILABLE]: 'Unavailable',
  [STAGE_VALUES.OFF]: 'Off',
  [STAGE_VALUES.ON]: 'On',
  [STAGE_VALUES.TRIM]: 'Trim',
};

/** Diagonal dark stripes for Trim segments, matching the table's trim cell style. */
export const TRIM_STRIPE_COLOR = '#191919';
/**
 * Horizontal distance between stripe start points. The CSS gradient repeats
 * every 10px perpendicular to the 135° stripe direction; to match on canvas
 * where we offset horizontally, multiply by √2 ≈ 1.414.
 */
export const TRIM_STRIPE_SPACING = 14;
export const TRIM_STRIPE_WIDTH = 5;

/** Minimum opacity at the faded end of ramp gradients. */
export const RAMP_GRADIENT_MIN_OPACITY = 0.04;

export const BAR_BORDER_RADIUS = 0;
/** Solid border for all bars. */
export const RAMP_BORDER_COLOR = CHART_GREEN;
export const RAMP_BORDER_WIDTH = 1.5;

export const LOOKBACK_MINUTES = 60;
export const FORECAST_MINUTES = 60;
/** How far back the chart x-axis extends (narrower than the data query window). */
export const CHART_LOOKBACK_MINUTES = 5;
/** How far ahead the chart x-axis extends (narrower than the data query window). */
export const CHART_FORECAST_MINUTES = 30;

/** Pixel offset from chart canvas top to plot area (label above accounts for the rest of the table header). */
export const CHART_GRID_TOP = 18;
/** Pixel space reserved at chart bottom for the x-axis time labels. */
export const CHART_GRID_BOTTOM = 28;
/** Pixel height per compressor row, matching the COMFORTABLE density table rows. */
export const CHART_ROW_HEIGHT = 33;
